export const environment = {
  production: false,
  eliquaRestURL: 'https://notos.uat.qivos.net/ci-notos-UAT/rest/v1/',
  clientName: 'notos',
};
